module.exports = __webpack_public_path__ + "static/4refuel-logo-af97493353c2e940ebdf91c4735fdc5d.jpg";